import { render, staticRenderFns } from "./a08c112b-fbb5-4df4-a819-fd3e9b43629f.vue?vue&type=template&id=0c2b2a64&scoped=true"
import script from "./a08c112b-fbb5-4df4-a819-fd3e9b43629f.vue?vue&type=script&lang=ts"
export * from "./a08c112b-fbb5-4df4-a819-fd3e9b43629f.vue?vue&type=script&lang=ts"
import style0 from "./a08c112b-fbb5-4df4-a819-fd3e9b43629f.vue?vue&type=style&index=0&id=0c2b2a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b2a64",
  null
  
)

export default component.exports